import tinycolor from 'tinycolor2';

export function getInvertedColor(
  color: string,
  colors = ['rgb(255, 255, 255)', 'rgb(17, 17, 17)'],
  brightness = 128
) {
  const [lightColor, darkColor] = colors;
  return tinycolor(color).getBrightness() < brightness ? lightColor : darkColor;
}

export function getBrightInvertedColor(
  color: string,
  colors = ['rgb(255, 255, 255)', 'rgb(17, 17, 17)']
) {
  return getInvertedColor(color, colors, 186);
}
